import type { MeshServerArchive } from "../io/meshServer";
import type { CoreApi, TcItem } from "./coreApi";

export type { MeshServerArchive };

/** Archive descriptor for a mesh opened from the Trimble Connect project browser (or a share
 *  link's own browser, which is just another `CoreApi`). */
export function archiveFromConnectFile(api: CoreApi, item: TcItem): MeshServerArchive | undefined {
  if (!api.resolvedBaseUrl) return undefined;
  return {
    kind: "connect",
    fileId: item.id,
    versionId: item.versionId,
    baseUrl: api.resolvedBaseUrl,
    // A share-opened browser authenticates with its own scoped token, distinct from the
    // caller's own identity token the server separately verifies (see `auth.ts`) — passed
    // through explicitly so the server can resolve the download URL the same way the
    // browser would.
    archiveToken: api.usingShareToken ? (api.shareAccessToken ?? undefined) : undefined,
  };
}

/** Archive descriptor for a mesh opened directly by URL (`?mesh=`, the `🔗` picker). */
export function archiveFromUrl(url: string): MeshServerArchive {
  return { kind: "url", url };
}
